var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.messagesLoading,
          expression: "messagesLoading"
        }
      ],
      class: { "on-mobile": _vm.$store.state.chat.isMobileMode },
      attrs: { id: "ChatBox" }
    },
    [
      _c(
        "div",
        {
          staticClass: "panel panel-default",
          class: { "on-mobile": _vm.$store.state.chat.isMobileMode }
        },
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              {
                staticClass: "uk-grid-small uk-flex-middle",
                attrs: { "uk-grid": "" }
              },
              [
                _c("div", { staticClass: "uk-width-auto" }, [
                  _vm.$store.state.chat.isMobileMode
                    ? _c("span", {
                        style: { color: "white", cursor: "pointer" },
                        attrs: { "uk-icon": "icon:  chevron-left; ratio: 2.5" },
                        on: { click: _vm.fnreturnListChat }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeChatCustomer.custImage,
                          expression: "activeChatCustomer.custImage"
                        }
                      ]
                    },
                    [
                      _c("img", {
                        staticClass: "uk-border-circle",
                        staticStyle: { width: "54px", height: "54px" },
                        attrs: {
                          width: "64",
                          height: "64",
                          src:
                            "https://cdnx.softsq.com/thumb/unsafe/84x84/" +
                            encodeURIComponent(
                              encodeURIComponent(
                                _vm.activeChatCustomer.custImage
                              )
                            ),
                          "data-src": "holder.js/64x64",
                          "data-holder-rendered": "true"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "uk-width-expand" }, [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "uk-margin-remove-bottom uk-margin-remove-top",
                      style: { color: "white" }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.activeChatCustomerName) +
                          "\n            "
                      ),
                      !_vm.activeChatCustomer.hold
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "pointer",
                              staticStyle: { "margin-left": "8px" },
                              attrs: {
                                effect: "plain",
                                size: "medium",
                                type: "info"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$store.dispatch(
                                    "chat/holdActiveChatCustomer"
                                  )
                                }
                              }
                            },
                            [_vm._v("Hold")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeChatCustomer.hold
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "pointer",
                              staticStyle: { "margin-left": "8px" },
                              attrs: {
                                effect: "dark",
                                size: "medium",
                                type: "warning"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$store.dispatch(
                                    "chat/unHoldActiveChatCustomer"
                                  )
                                }
                              }
                            },
                            [_vm._v("Hold")]
                          )
                        : _vm._e(),
                      _vm._v("\n             \n            "),
                      _c("span", [
                        _vm._v(
                          "ชื่อเดิม: " + _vm._s(_vm.activeChatCustomer.custName)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.1em",
                            cursor: "pointer"
                          },
                          on: {
                            click: function($event) {
                              return _vm.copyName(
                                _vm.activeChatCustomer.custName
                              )
                            }
                          }
                        },
                        [_c("u", [_vm._v("Copy to clipboard")])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "icon-edit",
                      on: {
                        click: function($event) {
                          return _vm.$store.dispatch(
                            "contact/setActiveContactCustumer",
                            _vm.activeChatCustomer
                          )
                        }
                      }
                    },
                    [_c("i", { staticClass: "far fa-edit" })]
                  )
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.$store.state.chat.isMobileMode
        ? _c("div", { staticClass: "ChatBox_writeSpace" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ChatBox__Content" },
        [
          _c(
            "transition",
            { attrs: { name: "component-fade", mode: "out-in" } },
            [
              _vm.messageScroll.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "tag-newMessage",
                      on: { click: _vm.setScrollDown }
                    },
                    [
                      _c("el-tag", { attrs: { type: "success" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              "ข้อความมาใหม่ " +
                                _vm.messageScroll.length +
                                " ข้อความ"
                            ) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "scroller",
            {
              ref: "ChatBox__List",
              staticClass: "ChatBox__List",
              attrs: { isbuttom: _vm.scrollStatus == "Down" },
              on: {
                "on-scroll-top": _vm.loadMessageScroll,
                "on-scroll-bottom": function($event) {
                  return _vm.$store.dispatch("chat/checkScrollTop", "Down")
                }
              }
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadMore,
                    expression: "loadMore"
                  }
                ],
                staticClass: "ChatBox__loading"
              }),
              _vm._v(" "),
              _vm._l(_vm.messages, function(message) {
                return _c("ChatMessage", {
                  key: message._id,
                  ref: "dropbox",
                  refInFor: true,
                  attrs: { data: message, resId: _vm.profile.reservationId },
                  on: { fnReSendMessage: _vm.reSendMessage }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowHistory,
                  expression: "!isShowHistory"
                }
              ],
              staticClass: "ChatBox__Input",
              class: { "on-mobile": _vm.$store.state.chat.isMobileMode }
            },
            [
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mesSuggest,
                          expression: "mesSuggest"
                        }
                      ],
                      staticClass: "text-warining"
                    },
                    [
                      _vm._v(
                        "\n          สคริปข้อความ : " +
                          _vm._s(_vm.mesSuggest) +
                          "\n        "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _c("el-alert", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isCheckMsg,
                        expression: "isCheckMsg"
                      }
                    ],
                    attrs: {
                      title:
                        "สคริปข้อความ : ข้อความเกิน 2000 ตัวอักษรไม่สามารถส่งข้อความได้",
                      type: "error"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _c("sticker", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShowSticker,
                        expression: "isShowSticker"
                      }
                    ],
                    on: { "send-sticker-line": _vm.sendStickerToLine }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _c("image-often", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShowOftenImages,
                        expression: "isShowOftenImages"
                      }
                    ],
                    on: { "send-imageOften-line": _vm.sendImageOftenToLine }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("vue-dropzone", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isShowDropzone &&
                      !_vm.isShowMessageSuggest &&
                      !_vm.isShowSticker,
                    expression:
                      "isShowDropzone && !isShowMessageSuggest && !isShowSticker"
                  }
                ],
                ref: "myVueDropzone",
                class: { "on-mobile": _vm.$store.state.chat.isMobileMode },
                attrs: { options: _vm.dropzoneOptions, id: "myDropzone" },
                on: {
                  "vdropzone-sending": _vm.vsending,
                  "vdropzone-success": _vm.vsuccess,
                  "vdropzone-removed-file": _vm.vremoved
                }
              }),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _vm.isShowBtnDownScroll
                    ? _c("el-button", {
                        ref: "btnScrollDown",
                        staticClass: "btn-down",
                        attrs: {
                          type: "primary",
                          icon: "el-icon-caret-bottom",
                          circle: ""
                        },
                        on: { click: _vm.setScrollDown }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$store.state.chat.isMobileMode
                ? _c(
                    "transition",
                    { attrs: { name: "component-fade", mode: "out-in" } },
                    [
                      _c(
                        "el-form",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.isShowDropzone &&
                                !_vm.isShowProductSearch &&
                                !_vm.isShowSticker &&
                                !_vm.isShowOftenImages &&
                                !_vm.$store.state.chat.disableSendMessage,
                              expression:
                                "\n            !isShowDropzone &&\n              !isShowProductSearch &&\n              !isShowSticker &&\n              !isShowOftenImages &&\n              !$store.state.chat.disableSendMessage\n          "
                            }
                          ],
                          staticClass: "form-tag",
                          attrs: { id: "formSuggestMsg" }
                        },
                        [
                          _vm._l(_vm.messageSuggest, function(mes) {
                            return _c("massage-suggest", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowRefBooking,
                                  expression: "!isShowRefBooking"
                                }
                              ],
                              key: mes.text,
                              attrs: { data: mes },
                              on: {
                                messageSuggest: _vm.sendMessageSuggest,
                                hoverMessage: _vm.sendhoverMessage
                              }
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.activeChatCustomer.refCode.length > 0,
                                  expression:
                                    "activeChatCustomer.refCode.length > 0"
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.refLoading,
                                  expression: "refLoading"
                                }
                              ]
                            },
                            [
                              _vm._l(_vm.activeChatCustomer.refCode, function(
                                ref
                              ) {
                                return _c("list-ref", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isShowRefBooking,
                                      expression: "isShowRefBooking"
                                    }
                                  ],
                                  key: ref,
                                  attrs: { data: ref },
                                  on: { fnSendRef: _vm.fnOpenAdatForBooking }
                                })
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isShowRefBooking,
                                      expression: "isShowRefBooking"
                                    }
                                  ],
                                  staticClass: "text-center",
                                  staticStyle: {
                                    "padding-bottom": "10px",
                                    "padding-top": "10px"
                                  },
                                  on: { click: _vm.fnCreateAdatnotProductCode }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        size: "medium",
                                        plain: ""
                                      }
                                    },
                                    [_vm._v("สร้างความต้องการลูกค้า")]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.activeChatCustomer.refCode.length == 0,
                                  expression:
                                    "activeChatCustomer.refCode.length == 0"
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.refLoading,
                                  expression: "refLoading"
                                }
                              ],
                              staticClass: "text-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isShowRefBooking,
                                      expression: "isShowRefBooking"
                                    }
                                  ],
                                  staticClass: "msg-pimary"
                                },
                                [_vm._v("ไม่มีข้อมูลโปรดักที่เสนอลูกค้า")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isShowRefBooking,
                                      expression: "isShowRefBooking"
                                    }
                                  ],
                                  staticClass: "text-center",
                                  staticStyle: {
                                    "padding-bottom": "10px",
                                    "padding-top": "10px"
                                  },
                                  on: { click: _vm.fnCreateAdatnotProductCode }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        size: "medium",
                                        plain: ""
                                      }
                                    },
                                    [_vm._v("สร้างความต้องการลูกค้า")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.chat.isMobileMode
                ? _c(
                    "transition",
                    { attrs: { name: "component-fade", mode: "out-in" } },
                    [
                      _c(
                        "el-form",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowRefBooking,
                              expression: "isShowRefBooking"
                            }
                          ],
                          staticClass: "form-tag",
                          class: {
                            "on-mobile": _vm.$store.state.chat.isMobileMode
                          },
                          attrs: { id: "formRefCode" }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.activeChatCustomer.refCode.length > 0,
                                  expression:
                                    "activeChatCustomer.refCode.length > 0"
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.refLoading,
                                  expression: "refLoading"
                                }
                              ]
                            },
                            _vm._l(_vm.activeChatCustomer.refCode, function(
                              ref
                            ) {
                              return _c("list-ref", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowRefBooking,
                                    expression: "isShowRefBooking"
                                  }
                                ],
                                key: ref,
                                attrs: { data: ref },
                                on: { fnSendRef: _vm.fnOpenAdatForBooking }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.activeChatCustomer.refCode.length == 0,
                                  expression:
                                    "activeChatCustomer.refCode.length == 0"
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.refLoading,
                                  expression: "refLoading"
                                }
                              ],
                              staticClass: "text-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isShowRefBooking,
                                      expression: "isShowRefBooking"
                                    }
                                  ],
                                  staticClass: "msg-pimary"
                                },
                                [_vm._v("ไม่มีข้อมูลโปรดักที่เสนอลูกค้า")]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowDropzone && _vm.isShowProductSearch,
                          expression: "!isShowDropzone && isShowProductSearch"
                        }
                      ],
                      staticClass: "form-tag",
                      class: {
                        "on-mobile": _vm.$store.state.chat.isMobileMode
                      },
                      attrs: { id: "formSearchProductCode" }
                    },
                    [
                      _c("product-search", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.productLoading,
                            expression: "productLoading"
                          }
                        ],
                        ref: "listProductSearch",
                        attrs: { data: _vm.mouthProduct }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("ul", { staticClass: "nav nav-pills" }, [
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.$store.state.chat.disableSendMessage,
                        expression: "!$store.state.chat.disableSendMessage"
                      }
                    ],
                    ref: "clicksent",
                    on: { click: _vm.sentToCustomer }
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.$store.state.chat.disableSendMessage,
                        expression: "!$store.state.chat.disableSendMessage"
                      }
                    ],
                    ref: "upload_file"
                  },
                  [
                    _c(
                      "a",
                      {
                        ref: "link_uploadfile",
                        staticClass: "file-upload",
                        on: { click: _vm.selectFileUpload }
                      },
                      [_c("i", { staticClass: "fas fa-paperclip fa-2x" })]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.$store.state.chat.disableSendMessage,
                        expression: "!$store.state.chat.disableSendMessage"
                      }
                    ],
                    ref: "sticker"
                  },
                  [
                    _c(
                      "a",
                      { ref: "link_sticker", on: { click: _vm.fnOpenSticker } },
                      [_c("i", { staticClass: "far fa-smile fa-2x" })]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.$store.state.chat.disableSendMessage,
                        expression: "!$store.state.chat.disableSendMessage"
                      }
                    ],
                    ref: "often_images"
                  },
                  [
                    _c(
                      "a",
                      {
                        ref: "often_image",
                        on: { click: _vm.fnOpenOftenImages }
                      },
                      [_c("i", { staticClass: "fas fa-bookmark fa-2x" })]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.$store.state.chat.disableSendMessage,
                        expression: "!$store.state.chat.disableSendMessage"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "search-productcode" },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              placeholder: "ใส่รหัสตัวเลข 6 หลัก",
                              maxlength: "6"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.searchProduct($event)
                              }
                            },
                            model: {
                              value: _vm.productCode,
                              callback: function($$v) {
                                _vm.productCode = $$v
                              },
                              expression: "productCode"
                            }
                          },
                          [
                            _c("template", { slot: "prepend" }, [
                              _vm._v("MUSH")
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            size: "mini",
                            icon: "el-icon-search",
                            type: "primary"
                          },
                          on: { click: _vm.searchProduct }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("li", [
                  _c("div", { on: { click: _vm.fnOpenRefBooking } }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.activeChatCustomer.BookingId == 0 &&
                              !_vm.$store.state.chat.isMobileMode,
                            expression:
                              "\n                activeChatCustomer.BookingId == 0 &&\n                  !$store.state.chat.isMobileMode\n              "
                          }
                        ],
                        staticClass: "text-new",
                        attrs: { type: "primary", plain: "" }
                      },
                      [
                        _c("i", { staticClass: "far fa-check-square" }),
                        _vm._v(" Booking ที่ลูกค้าสนใจ\n            ")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { on: { click: _vm.fnOpenBooking } }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeChatCustomer.BookingId != 0,
                            expression: "activeChatCustomer.BookingId != 0"
                          }
                        ],
                        staticClass: "text-new msg-success",
                        attrs: { type: "primary", plain: "" }
                      },
                      [
                        _c("i", { staticClass: "fas fa-external-link-alt" }),
                        _vm._v(" Booking ที่จองล่าสุด\n            ")
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  ref: "fromMsg",
                  attrs: { action: "/", method: "post" },
                  on: { submit: _vm.sendMessage }
                },
                [
                  _c("canvas", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isShowInput,
                        expression: "!isShowInput"
                      }
                    ],
                    attrs: { id: "mycanvas" }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "input-mssage hidden",
                    attrs: { type: "text" },
                    domProps: { textContent: _vm._s(_vm.urlCopyImage) }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowInput,
                          expression: "!isShowInput"
                        }
                      ],
                      staticClass: "btn btn-default btn-sm",
                      attrs: { type: "button" }
                    },
                    [_vm._v("\n          Remove\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.$store.state.chat.messageReplying
                    ? _c("div", { staticClass: "replying-box" }, [
                        _c(
                          "div",
                          [
                            _c("strong", [_vm._v("ตอบกลับข้อความ")]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "warning",
                                  round: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$store.commit(
                                      "chat/messageReplying",
                                      null
                                    )
                                  }
                                }
                              },
                              [_vm._v("ยกเลิก")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "message-reply-preview" }, [
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  this.$store.state.chat.messageReplying
                                    .custName
                                ) + ":\n              "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.replyHtml()) }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShowInput,
                        expression: "isShowInput"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newMessages,
                        expression: "newMessages"
                      }
                    ],
                    ref: "inputMsg",
                    staticClass: "input-mssage",
                    attrs: {
                      id: "chat-input",
                      type: "text",
                      rows: "5",
                      cols: "4",
                      disabled: _vm.$store.state.chat.disableSendMessage,
                      placeholder: _vm.$store.state.chat.disableSendMessage
                        ? _vm.$store.state.chat.disableSendMessageReason
                        : "Enter your message here"
                    },
                    domProps: { value: _vm.newMessages },
                    on: {
                      keypress: _vm.sendMessage,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.newMessages = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.$store.state.chat.disableSendMessage
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "18px",
                            margin: "8px"
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://business.facebook.com/latest/inbox",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Go to Facebook Inbox\n          "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [_c("i", { staticClass: "fa fa-paper-plane fa-2x" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fa2e3d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa2e3d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatBox.vue
// module id = null
// module chunks = 